module.exports = __webpack_public_path__ + "img/bill-refuse.05f27b04.png";